import { useState, useEffect, useRef } from 'react';
import { some, mapValues } from 'lodash-es';

// Structure example of observableMenusRefs
// {
//   store: storeSlotRef,
//   categories: categorySlotRef,
// }

function useMenuAligns(parentContainerRef, observableMenusRefs, recalculateFlag, {
  initialAligns = {},
} = {}) {
  const [menuAligns, setMenuAligns] = useState(
    mapValues(observableMenusRefs, (_, key) => initialAligns[key] || 'start'),
  );

  const memoObservableMenusRefs = useRef();
  memoObservableMenusRefs.current = observableMenusRefs;

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      const { left, right } = parentContainerRef.current.getBoundingClientRect();
      const getMenuAlign = menuRect => (right - menuRect.right > menuRect.left - left ? 'start' : 'end');
      const nextMenuAligns = mapValues(memoObservableMenusRefs.current, menuRef => (
        getMenuAlign(menuRef.current.getBoundingClientRect())
      ));

      setMenuAligns((prevState) => {
        if (some(prevState, (v, k) => nextMenuAligns[k] !== v)) {
          return nextMenuAligns;
        }

        return prevState;
      });
    });

    resizeObserver.observe(parentContainerRef.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, [recalculateFlag]);

  return menuAligns;
}

export default useMenuAligns;
